import { IconProps } from './icons-props';

function HeadPhoneIcon({ className, width = 22, height = 22 }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 22 22'
            fill='none'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.56995 21.6998C2.22995 21.6998 0.249952 19.7198 0.249952 17.3798V11.2198C0.199952 8.2998 1.27995 5.5498 3.29995 3.4898C5.31995 1.4398 8.02995 0.299805 10.95 0.299805C16.91 0.299805 21.75 5.14981 21.75 11.0998V17.2598C21.75 19.6398 19.81 21.5798 17.43 21.5798C15.09 21.5798 13.11 19.5998 13.11 17.2598V14.4498C13.11 12.9998 14.25 11.8598 15.7 11.8598C17.15 11.8598 18.29 12.9998 18.29 14.4498V17.4798C18.29 17.8898 17.95 18.2298 17.54 18.2298C17.13 18.2298 16.79 17.8898 16.79 17.4798V14.4498C16.79 13.7698 16.24 13.3598 15.7 13.3598C15.02 13.3598 14.61 13.9098 14.61 14.4498V17.2598C14.61 18.7898 15.9 20.0798 17.43 20.0798C18.96 20.0798 20.25 18.7898 20.25 17.2598V11.0998C20.25 5.9698 16.08 1.7998 10.95 1.7998C8.43995 1.7998 6.10995 2.7698 4.36995 4.5398C2.62995 6.3098 1.69995 8.6798 1.74995 11.1998V17.3798C1.74995 18.9098 3.03995 20.1998 4.56995 20.1998C6.09995 20.1998 7.38995 18.9098 7.38995 17.3798V14.5698C7.38995 13.8898 6.83995 13.4798 6.29995 13.4798C5.61995 13.4798 5.20995 14.0298 5.20995 14.5698V17.4898C5.20995 17.8998 4.86995 18.2398 4.45995 18.2398C4.04995 18.2398 3.70995 17.8998 3.70995 17.4898V14.5698C3.70995 13.1198 4.84995 11.9798 6.29995 11.9798C7.74995 11.9798 8.88995 13.1198 8.88995 14.5698V17.3798C8.88995 19.7198 6.90995 21.6998 4.56995 21.6998Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default HeadPhoneIcon;

